'use strict';

var jcalendar = require('../jcalendar'),
	formPrepare = require('./checkout/formPrepare');

exports.init = function () {
	formPrepare.init({
		continueSelector: '[name$="booktable_submit"]',
		formSelector: '.book_hotelrestaurant_form'
	});
	jcalendar.init($('[name$="_booktable_date"]'), {
		'container':$('.date-wrapper')
	});
};